import isMobile from 'ismobilejs';

export default new class UserAgentDetector {
  constructor() {
    this.isMobile = isMobile(window.navigator);
    this.checkBrowser()
  }

  get isIOSSafari() {
    return this.isMobile.apple.phone && navigator.vendor && navigator.vendor.indexOf("Apple") > -1 && navigator.userAgent && -1 === navigator.userAgent.indexOf("CriOS") && -1 === navigator.userAgent.indexOf("FxiOS");
  }

  checkBrowser() {
    this.isOpera = /Opera Mini\/|OPM\/|OPR\//i.test(window.navigator.userAgent);
  }
}
